import request from '@/api/request'
/**
 * 获取合作项目介绍
 */
export const getProjectContent = () => {
    return request({
        url: '/radioweb/app/cooperationProject/getListPage',
        method: 'get'
    })
}
/**
 * 提交申请
 */
export const addCooperationApply = (data) => {
    return request({
        url: '/base/app/cooperationApply/addCooperationApply2',
        method: 'post',
        data
    })
}
